














import { Component, Emit, Vue } from 'vue-property-decorator'

import { Getter } from 'vuex-class'

import { brandUrl } from '@/apiClient'

@Component
export default class BrandImage extends Vue {
  didLoadImage = false

  get srcUrl (): string {
    return brandUrl(this.providerId)
  }

  @Getter('auth/currentProvider')
  readonly providerId!: number

  @Emit()
  loaded (success: boolean) {
    this.didLoadImage = success
  }
}
